"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ballabio": {
    "1380ae13": [{
      "hkey": "6a132eac",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "ballabio-inferiore": [{
      "hkey": "6a132eac",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ca904d8e": [{
      "hkey": "6a132eac",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "ballabio-superiore": [{
      "hkey": "6a132eac",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ballabio"
    }],
    "9f690691": [{
      "hkey": "1c1441ef",
      "slug": "ballabio",
      "name": "Ballabio",
      "primary": true,
      "skipSearch": false
    }],
    "rifugio-cavalletti": [{
      "hkey": "1c1441ef",
      "slug": "ballabio",
      "name": "Ballabio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;